import type { Trip } from '@/content/trips/manifest'

export type TripStatus = 'upcoming' | 'active' | 'past'

/**
 * Derive a trip's status from its dates.
 *
 * Rules:
 * - `endDate < now` → `past`
 * - `startDate <= now <= endDate` → `active`
 * - `startDate > now` → `upcoming`
 *
 * `now` is injectable so callers (and future tests) can freeze time.
 * Dates are ISO `YYYY-MM-DD` strings; comparison is lexicographic which
 * is safe for this format.
 */
export function getTripStatus(
  trip: Pick<Trip, 'startDate' | 'endDate'>,
  now: Date = new Date()
): TripStatus {
  const today = now.toISOString().slice(0, 10)
  if (trip.endDate < today) return 'past'
  if (trip.startDate > today) return 'upcoming'
  return 'active'
}

export const STATUS_LABEL: Record<TripStatus, string> = {
  upcoming: 'Upcoming',
  active: 'Active',
  past: 'Past',
}
